import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { NotificationService } from '../../../../../common/services/notification/notification.service';
import { Error, CustomHttpErrorResponse } from '../../../../../common/constants/error';
import {
  ShipmentSpecialFreightNotificationsLoad,
  ShipmentSpecialFreightNotificationsSetInitialState,
} from './shipment-special-freight-notifications.actions';
import { ShipmentSpecialFreightNotificationsService } from './shipment-special-freight-notifications.service';
import { LatestNotification } from '../../../monitoring/models';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface ShipmentSpecialFreightNotificationsStateModel {
  notifications: LatestNotification[];
  loaded: boolean;
}

const initialState: ShipmentSpecialFreightNotificationsStateModel = {
  notifications: null,
  loaded: false,
};

@State<ShipmentSpecialFreightNotificationsStateModel>({
  name: 'shipmentSpecialFreightNotifications',
  defaults: initialState,
})
@Injectable()
export class ShipmentSpecialFreightNotificationsState {
  constructor(
    private shipmentSpecialFreightNotificationsService: ShipmentSpecialFreightNotificationsService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  static getLoaded(state: ShipmentSpecialFreightNotificationsStateModel): boolean {
    return state.loaded;
  }

  @Selector()
  static getNotifications(state: ShipmentSpecialFreightNotificationsStateModel): LatestNotification[] {
    return state.notifications;
  }

  @Action(ShipmentSpecialFreightNotificationsLoad)
  getShipmentSpecialFreightNotifications(
    ctx: StateContext<ShipmentSpecialFreightNotificationsStateModel>,
    { payload }: ShipmentSpecialFreightNotificationsLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.shipmentSpecialFreightNotificationsService.getShipmentSpecialFreightNotifications(payload).pipe(
      map((notifications: LatestNotification[]) => {
        ctx.patchState({ notifications, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(ShipmentSpecialFreightNotificationsSetInitialState)
  setInitialState(ctx: StateContext<ShipmentSpecialFreightNotificationsStateModel>): void {
    ctx.setState(initialState);
  }
}
